/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from "underscore";
import SearchLayout from "components/layouts/search-layout";
import { getProductPageRegex } from "routing/routes";

var FILTER_KEYS = [
    "category",
    "product_type",
    "subcategory",
    "color",
    "sizes",
    "gender",
    "usd_price",
    "eur_price",
    "gbp_price",
    "final_price",
    "final_price_from",
    "final_price_to",
    "discount",
    "discount_from",
    "stock_status",
    "designer_slug",
    "retailer_slug",
    "sale",
    "show_only",
    "icon",
    "material",
    "free_shipping",
    "filter_keyword"
];

var filterExtractor = _.partial(_.pick, _, FILTER_KEYS);
var metaFilterExtractor = _.partial(
    _.pick,
    _,
    FILTER_KEYS.map(function(key) {
        return "meta_" + key;
    })
);

function makeOptions(queryParams) {
    let page = queryParams.page ? parseInt(queryParams.page[0], 10) : 1;
    return {
        page,
        query: queryParams.q[0],
        term: queryParams.term,
        alternatives: queryParams.alternatives,
        filters: filterExtractor(queryParams),
        metaFilters: metaFilterExtractor(queryParams),
        view: queryParams.view
    };
}

export default {
    enter(path, queryParams, parent) {
        let layout = parent.findComponent("search-layout");

        if (!layout) {
            layout = new SearchLayout(makeOptions(queryParams));
            layout.appendTo(parent.getLayoutContainer());
        }

        return layout;
    },

    update(path, queryParams, searchLayout) {
        searchLayout.updateOptions(makeOptions(queryParams));
    },

    exit(path, queryParams, searchLayout) {
        if (path.match(getProductPageRegex())) {
            return;
        }

        searchLayout.destroy();
    }
};

